import { faArrowDownAZ, faArrowUpZA, faArrowDownUpAcrossLine } from '@fortawesome/free-solid-svg-icons'

export const handleSort = (setSortState, column) => {
  setSortState((prevSort) => {
    const newDirection = prevSort.column === column && prevSort.direction === 'asc' ? 'desc' : 'asc';
    return { column, direction: newDirection };
  });
};

export const sortData = (data, column, direction) => {
  if (!column || !data || data.length === 0) return data;

  return data.map((item) => ({ ...item })).sort((a, b) => {
    const aVal = a[column];
    const bVal = b[column];

    const aNum = Number(aVal);
    const bNum = Number(bVal);

    if (!Number.isNaN(aNum) && !Number.isNaN(bNum)) {
      return direction === 'asc' ? aNum - bNum : bNum - aNum;
    }

    const aStr = String(aVal).toLowerCase();
    const bStr = String(bVal).toLowerCase();
    return direction === 'asc' ? aStr.localeCompare(bStr) : bStr.localeCompare(aStr);
  });
};

export const getSortIcon = (column, sortState) => {
  if (sortState.column !== column) return faArrowDownUpAcrossLine;
  return sortState.direction === 'asc' ? faArrowDownAZ : faArrowUpZA;
};

export const getStatusClass = (status) => {
  if (status === 'approved') return 'is-success';
  if (status === 'denied') return 'is-danger';
  if (status === 'pending') return 'is-warning';
  return 'is-light';
};

export const getBankChangeStatusFromManagerApproval = (managerApproval, findDropdownOption) => {
  if (!managerApproval?.mgr_approval_status_dropdown_option_id) return 'pending';

  const statusOption = findDropdownOption(managerApproval.mgr_approval_status_dropdown_option_id, 'id');
  if (!statusOption) return 'pending';

  switch (statusOption.code_key) {
    case 'mgr_approval_status_approved':
      return 'approved';
    case 'mgr_approval_status_declined':
      return 'denied';
    case 'mgr_approval_status_required':
      return 'pending';
    default:
      return 'pending';
  }
};
